import React, {useState} from 'react';
import store from "../../redux/store";
import {Route, Routes} from "react-router-dom";

import Aqllisuv from "./pages/aqllisuv/AqlliSuv";
import SuvdanfoydalanishSahifa from "./pages/suvdanfoydalanish";
import VegetatsiyaSahifa from "../republik/pages/sugorish/vegetatsiya/VegetatsiyaSahifa";
import NovegetatsiyaSahifa from "../republik/pages/sugorish/novegetatsiya/NovegetatsiyaSahifa";
import LimitSahifa from "../republik/pages/limitlar/LimitSahifa";

import NotFound from "../notfound/NotFound";
import {Provider} from "react-redux";
import MainLayout from "./layout/MainLayout";
import BoshSahifa from "./pages/Dashboard/BoshSahifa";
import Sfr from "./pages/sfr/Sfr";

function Index(props) {
    const [date, setDate] = useState(new Date().toISOString().slice(0,10))
    return (
        <Provider store={store}>
            <Routes>
                <Route element={<MainLayout date={date} setDate={setDate}/>}>
                    <Route index element={<BoshSahifa date={date}/>} />
                    <Route path="aqllisuv/*" element={<Aqllisuv />} />
                    <Route path="suvdanfoydalanish/*" element={<SuvdanfoydalanishSahifa />} />
                    <Route path="vegetatsiya/*" element={<VegetatsiyaSahifa />} />
                    <Route path="novegetatsiya/*" element={<NovegetatsiyaSahifa />} />
                    <Route path="limit/*" element={<LimitSahifa />} />
                    <Route path="sfr/*" element={<Sfr />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Provider>
    );
}

export default Index;